import React, { useEffect, useState } from "react";
import { getErrorMessage } from "../utils/Errors";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Space from "../ui/Space";
import Card from "../ui/Card";
import Menu from "../ui/Menu";
import VirtualTable from "../ui/VirtualTable";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import InventoryDetails from "../components/InventoryDetails";

export default function AuthorPickerScreen(props) {

    const { controller = "", author = "", callback = () => { }, setStock = () => { }, route = "", stock_data = {} } = props;
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [selectedTitle, setSelectedTitle] = useState({});
    const [left, setLeft] = useState(true);

    const fetchAuthor = () => {
        pubCall("stock.searchAuthor", { author_name: author }, (_s, _r) => {
            if (_s) {
                if (_r.length > 0) {
                    setData(_r);
                    setSelected(_r[0]);
                } else {
                    setSelected({});
                    setSelectedTitle({});
                }
            } else {
                showError({error : getErrorMessage(_r.error, "stock.searchAuthor")})
            }
        })
    }
    useEffect(fetchAuthor, [])

    useEffect(() => {
        if (selected?.titles) {
            setSelectedTitle(selected?.titles[0])
            setStock(selected?.titles[0])
        }
    }, [selected])


    useEffect(() => {
            setStock(selectedTitle);
    }, [selectedTitle])
    


    const switchSides = (_left = true) => {

        if (_left) {
            window.bm_state.value = route;
        } else {
            window.bm_state.value = ROUTES.INVENTORY.AUTHORPICKER_TITLE;
        }

        setLeft(_left);

    }

    const setAuthor = () => {
        let obj = {
            author: selected?.author,
            title: selectedTitle
        }
        callback(obj);
    }

    useEffect(() => {
        const actions = [
            { key: KBD.ENTER, action: (e) => { setAuthor() } },
            { key: KBD.ESCAPE, action: (e) => { callback() } },
            { key: KBD.ARROW_LEFT, action: (e) => { switchSides(true) } },
        ];
        const cleanup = listen(controller, ROUTES.INVENTORY.AUTHORPICKER_TITLE, actions, false);
        return cleanup;
    }, [selected, selectedTitle]);

    useEffect(() => {
        const actions = [
            { key: KBD.ENTER, action: (e) => { setAuthor() } },
            { key: KBD.ESCAPE, action: (e) => { callback() } },
            { key: KBD.ARROW_RIGHT, action: (e) => { switchSides(false) } },
        ];
        const cleanup = listen(controller, route, actions, false);
        return cleanup;
    }, [selected, selectedTitle]);


    const author_columns = [
        { key: "author", align: "left", title: <>Authors</>, width: 500 },
    ]

    const title_columns = [
        { key: "title", align: "left", title: <>Author's Titles</>, width: 550, },
        {
            key: "class", align: "left", title: <>Class</>, width: 276, render: (e, f) => {
                return (f?.category_1 + "-" + f?.category_2);
            }
        },
    ]

    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const currentIndex = data.findIndex(item => item?.author === selected?.author);
        const nextIndex = Math.min(currentIndex + _rows, data.length - 1);
        setSelected(data[nextIndex]);
    };

    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const currentIndex = data.findIndex(item => item?.author === selected?.author);
        const prevIndex = Math.max(currentIndex - _rows, 0);
        setSelected(data[prevIndex]);
    };

    const nextTitle = (_rows = 1) => {
        if (selected?.titles.length === 0) { setSelectedTitle({}); return; }
        const currentIndex = selected.titles.findIndex(item => item?.stock_id === selectedTitle?.stock_id);
        const nextIndex = Math.min(currentIndex + _rows, selected.titles.length - 1);
        setSelectedTitle(selected.titles[nextIndex]);
    };

    const prevTitle = (_rows = 1) => {
        if (selected?.titles.length === 0) { setSelectedTitle({}); return; }
        const currentIndex = selected.titles.findIndex(item => item?.stock_id === selectedTitle?.stock_id);
        const prevIndex = Math.max(currentIndex - _rows, 0);
        setSelectedTitle(selected.titles[prevIndex]);
    };


    const drawMessage = () => {
        if (left) {
            return (<>Select desired author ({data.length} available) Press {KBD.ARROW_RIGHT.label} to browse titles</>)
        } else {
            return (<>Browsing {selected?.author} titles.  Press {KBD.ARROW_LEFT.label} to browse authors</>)
        }
    }

    const getStock = () => {
        if(left){
            return stock_data;
        } else {
            return selectedTitle;
        }
    }

    return (
        <>
        <InventoryDetails controller={controller} updateRow={() => {}} switchEdit={() => {}} edit={false} stock_data={getStock} />
            <div className="shim" />
            <Space>
                <div style={{ "opacity": (!left) ? "0.7" : "1" }} onClick={() => switchSides(true)}>
                    <VirtualTable
                        controller={controller}
                        row_key={"author"}
                        next={next}
                        prev={prev}
                        route={route}
                        current={selected}
                        data={data}
                        width={500}
                        height={10}
                        offset={387}
                        onRowDoubleClick={() => setAuthor()}
                        columns={author_columns}
                        onRowClick={(item, event, index) => { switchSides(true); setSelected(item) }}
                    />
                </div>

                <div style={{ "opacity": (left) ? "0.7" : "1" }} onClick={() => switchSides(false)}>
                    <VirtualTable
                        controller={controller}
                        row_key={"stock_id"}
                        next={nextTitle}
                        prev={prevTitle}
                        onRowClick={(item) => { switchSides(false); setSelectedTitle(item) }}
                        onRowDoubleClick={() => setAuthor()}
                        route={ROUTES.INVENTORY.AUTHORPICKER_TITLE}
                        current={selectedTitle}
                        data={selected?.titles}
                        width={848}
                        height={10}
                        offset={387}
                        columns={title_columns}
                    />
                </div>

            </Space>
            <div className="shim" />
            <Status><InfoIcon />{drawMessage()}</Status>
        </>
    )
}